import { render } from "./BModal.vue?vue&type=template&id=1e9ed356&scoped=true"
import script from "./BModal.vue?vue&type=script&lang=js"
export * from "./BModal.vue?vue&type=script&lang=js"

import "./BModal.vue?vue&type=style&index=0&id=1e9ed356&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9ed356"]])

export default __exports__